import clsx from "clsx";
import React, { FC, PropsWithChildren } from "react";

export type SkeletonProps = PropsWithChildren<{
  className?: string;
  width?: number | string;
  height?: number | string;
  isLoading: boolean | undefined;
  as?: React.ElementType;
  lines?: number;
}>;

type SkeletonBlockProps = PropsWithChildren<
  Pick<SkeletonProps, "as" | "className" | "height" | "width">
>;

const SkeletonBlock: FC<SkeletonBlockProps> = ({
  children,
  as,
  className,
  width,
  height,
}) => {
  const Element = as ?? "div";
  return (
    <Element
      className={clsx(className, "bg-neutral-50 max-w-full animate-pulse", {
        "rounded-xs": !className?.includes("rounded"),
      })}
      style={{
        width: width,
        height: height,
      }}
    >
      {children}
    </Element>
  );
};

const Skeleton: FC<SkeletonProps> = ({
  children,
  isLoading,
  lines = 1,
  height,
  width,
  ...props
}) => {
  if (isLoading) {
    if (lines > 1) {
      return new Array(lines).fill(undefined).map((_, i) => (
        <div key={i} className="flex max-w-full" style={{ width: width }}>
          <SkeletonBlock {...props} height="1em" width="100%" />
          <span className="inline-block w-none overflow-hidden">&nbsp;</span>
        </div>
      ));
    }

    return (
      <SkeletonBlock {...props} width={width} height={height}>
        &nbsp;
      </SkeletonBlock>
    );
  }

  return <>{children}</>;
};

export default Skeleton;
